module.exports = __webpack_public_path__ + "img/事件管理@2x.2d887d96.png";